import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { AnnouncementBanner } from '@/components/AnnouncementBanner';
import { CookieConsent } from '@/components/CookieConsent';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // Sync i18n language with URL synchronously during render. The
  // useEffect-based sync in useLanguage only fires client-side, so SSG
  // renders default to i18n.init's initial lng and prerendered /en HTML
  // ships with Swedish copy. i18next.changeLanguage is synchronous when
  // resources are bundled (no async loader), and idempotent, so calling
  // it in render is safe in both SSG and client paths.
  const langFromPath = location.pathname.match(/^\/(sv|da|fi|no|en)(\/|$)/)?.[1];
  if (langFromPath && i18n.language !== langFromPath) {
    i18n.changeLanguage(langFromPath);
  }

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:text-sm focus:font-medium"
      >
        {t('common.skipToContent', 'Hoppa till innehåll')}
      </a>
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      <AnnouncementBanner />
      <CookieConsent />
    </div>
  );
}
